import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
import { buildWidths, MAX_ROWS } from '@/modules/builders/lib/skeletons-helpers';
import { BuildersProfileSkeleton } from '../builders-profile-skeleton/builders-profile-skeleton';
import { BuildersSkillsSkeleton } from '../builders-skills-skeleton/builders-skills-skeleton';
interface BuildersListItemSkeletonProps {
  builderNameWidth: number;
  builderSkillsWidth: number;
}
function BuildersListItemSkeleton(t0) {
  const $ = _c(16);
  const {
    builderNameWidth,
    builderSkillsWidth
  } = t0;
  let t1;
  if ($[0] !== builderNameWidth) {
    t1 = <BuildersProfileSkeleton builderNameWidth={builderNameWidth} />;
    $[0] = builderNameWidth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-5.5 w-8" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== builderSkillsWidth) {
    t3 = <div className="hidden flex-col gap-1 md:flex">{t2}<BuildersSkillsSkeleton builderSkillsWidth={builderSkillsWidth} /></div>;
    $[3] = builderSkillsWidth;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-end gap-1"><Skeleton className="h-9 w-9" /><Skeleton className="h-9 w-9" /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t3) {
    t5 = <div className="grid grid-cols-[auto_1fr] items-center gap-4 md:grid-cols-[45%_33%_1fr]">{t1}{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Skeleton className="h-5.5 w-8" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== builderSkillsWidth) {
    t7 = <div className="flex flex-col gap-1 md:hidden">{t6}<BuildersSkillsSkeleton builderSkillsWidth={builderSkillsWidth} /></div>;
    $[10] = builderSkillsWidth;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center justify-between"><Skeleton className="h-4.5 w-19.5" /><Skeleton className="h-5.5 w-21" /></div>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t7) {
    t9 = <div className="bg-background flex flex-col gap-3 rounded-xl p-2 shadow-sm">{t5}{t7}{t8}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
interface BuildersListSkeletonProps {
  className?: string;
}
function BuildersListSkeleton(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = buildWidths({
      min: 13,
      max: 40,
      seed: 12345
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const builderProfileWidths = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = buildWidths({
      min: 23,
      max: 38,
      seed: 67890
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const builderSkillsWidths = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("flex flex-col gap-2", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = Array.from({
      length: MAX_ROWS
    }, (_, index) => {
      const builderNameWidth = builderProfileWidths[index] ?? 13;
      const builderSkillsWidth = builderSkillsWidths[index] ?? 23;
      return <BuildersListItemSkeleton key={`builder-list-item-skeleton-${index}`} builderNameWidth={builderNameWidth} builderSkillsWidth={builderSkillsWidth} />;
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className={t3}>{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export { BuildersListSkeleton };